import type { ExploreAppsModalProps } from './ExploreAppsState';
import { MoreActionsPropItem } from './MoreActionsBase';

export interface MoreActionsProps {
  /**
   * Actions items that appear in the `MoreActions` popover menu. \
   * Actions can be grouped by using an array of arrays. \
   * Each sub-array represents a different group within the popover, \
   * and a divider will be rendered after each sub-array to separate the groups.
   * @overrideType [MoreActionsItem](./?path=/story/common-types--moreactionsitem)[] | [MoreActionsItem](./?path=/story/common-types--moreactionsitem)[][]
   * @external
   */
  items?: MoreActionsPropItem[] | MoreActionsPropItem[][];

  /**
   * An id of the container defined in the installed on a site application that contains TPA's actions.
   */
  containerId?: string;

  /**
   * Additional properties passed to the `onClick` of the container's extensions menu items.
   */
  containerProps?: Record<string, any>;

  /**
   * Additional info for cairoPageCtaClicked BI event.
   */
  biAdditionalInfo?: string;

  dataHook?: string;

  exploreAppsModalProps?: ExploreAppsModalProps;
}
